/**
 * 
 * TODO:
 *    scrollTo is now well supported, we can probably use this instead of pixel computations
 * 
 * 
 * nmcSlider
 * 
 * This is a slider that works a bit differently than most. It is based on manipulating a
 * container that has native browser scrolling. Typically some kind of 'slider object' is 
 * created that represents the whole operation, and it gets moved around using transforms
 * and javascript.
 * 
 * In this case, we allow that the slider can be natively manipulated by scrolling. Nothing
 * significant is built up around the slider itself. Instead, we are building functionality
 * around 'buttons' that can act upon arbitrary scrollable containers. Each button has a 
 * target that specifies which scrollable container to act upon, and an action, which is the
 * thing that will take place. A button might look like this:
 * 
 * <button data-nmc-slider-target="#some-slider" data-nmc-slider-action"next-2">Skip Ahead 2</button>
 * 
 * The target attribute is any selector. The action attribute is a key/value pair
 * separated by a hyphen.
 * 
 * Minimal state is maintained in the slider. To determine what 'next' means, the slider is
 * measured at the time the button is clicked so that it can advance to whatever slide is
 * next. This allows the slider to be natively scrolled without losing state.
 * 
 * Container Options:
 *  behavior    - what the default scroll behavior is, 'smooth' or 'auto' (instant)
 *  auto        - auto advancing based on the given number of ms
 *  direction   - set to 'rtl' for a right-to-left slider
 * 
 * Actions:
 * 
 *  next        - determine the current slide, advance some number past that
 *  prev        - determine the current slide, go back some number
 *  advance     - switch to a particular slide, clamped to the limits
 *  jump        - advance instantly to a particular slide
 *  scroll      - advance to a particular slide using smooth scrolling
 */

// This is an object to wrap a single element instance of a slider

/* The slider and the operations it allows */
(function(){
	window.nmcSlider = function(arg) {
		var self = this;
		this.$slider = (typeof arg === 'object') ? arg : document.querySelector(arg);
		this.currentCache = this.getCurrent();
		this.registeredButtons = [];
		this.interval = false;

		// if rtl initially scroll all the way to the right
		if (this.$slider.dataset.nmcSliderDirection == 'rtl') {
			this.$slider.rtl = true;
			// this.$slider.scrollLeft = this.$slider.scrollWidth;
		}
		this.$slider.addEventListener('scroll',function(e){
			if(self.currentCache != self.getCurrent()) {
				self.onChange();
			}
		});
		this.$slider.addEventListener('nmcSliderDispatch',function(e){
			// console.log(e.detail);
			self[e.detail.action](Number(e.detail.value));
		});
		this.$slider.addEventListener('nmcSliderButtonRegister',function(e){
			self.registeredButtons.push(e.detail.button);
			self._notifyButton(e.detail.button);
		});

		this.play();
	}

	/*

	Get Semi-Static Properties out of the Slider

	*/

	nmcSlider.prototype.getCurrent = function() {  // active slide based on scroll position
		var compStyles = window.getComputedStyle(this.$slider);
		var closestOffset = 99999999;
		var closestSlideNumber = 1;
		var offsetLeft = Math.abs(compStyles.getPropertyValue('padding-left').replace('px', ''));
		var offsetRight = Math.abs(compStyles.getPropertyValue('padding-right').replace('px', ''));
		var scrollLeft = this.$slider.scrollLeft;
		var clientWidth = this.$slider.clientWidth;

		for(var i = 1; i <= this.$slider.children.length; i++) {
			if (this.$slider.rtl) {
				var difference = Math.abs(scrollLeft + (clientWidth - this.$slider.children[i-1].offsetLeft - this.$slider.children[i-1].clientWidth - offsetRight));
			} else {
				var difference = Math.abs(scrollLeft + offsetLeft - this.$slider.children[i-1].offsetLeft);
			}
			if(difference < closestOffset) {
				closestOffset = difference;
				closestSlideNumber = i;
			}
		}

		this.currentCache = closestSlideNumber;
		return closestSlideNumber;
	}

	nmcSlider.prototype.getLength = function() {
		return this.$slider.children.length;
	}

	nmcSlider.prototype.getBehavior = function() {
		return typeof this.$slider.dataset.nmcSliderBehavior !== 'undefined' ? this.$slider.dataset.nmcSliderBehavior : 'smooth';
	}
	nmcSlider.prototype.shouldLoop = function(){
		var attr = this.$slider.dataset.nmcSliderLoop;
		var shouldLoop = (typeof attr !== 'undefined' && attr !== 'false');
		return (this.$slider.dataset.nmcSliderAuto > 0 || shouldLoop)
	}
	nmcSlider.prototype.isAtTheEnd = function() {
		return this.$slider.clientWidth == this.$slider.scrollWidth - this.$slider.scrollLeft;
	}
	nmcSlider.prototype.autoDuration = function(){
		return typeof this.$slider.dataset.nmcSliderAuto !== 'undefined' ? this.$slider.dataset.nmcSliderAuto : false;
	}
	nmcSlider.prototype.resetIframes = function(){
		return typeof this.$slider.dataset.nmcSliderResetIframes !== 'undefined' ? this.$slider.dataset.nmcSliderResetIframes : false; 
	}




	/*

	Slider Behaviors

	*/

	nmcSlider.prototype._setPlayButtonsState = function (isPlaying) {
		const playSVG  = '<svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" viewBox="-1 0 8 8"><path fill-rule="evenodd" d="M0 0v8l7-4z"/></svg>';
		const pauseSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none" viewBox="0 0 16 16"><path fill="#000" d="M7 1H2v14h5V1Zm7 0H9v14h5V1Z"/></svg>';

		this.registeredButtons.forEach(btn => {
			if (btn.dataset.nmcSliderAction === 'playpause') {
				btn.classList.toggle('playing', isPlaying);
				const icon = btn.querySelector('.icon');
				if (icon) icon.innerHTML = isPlaying ? pauseSVG : playSVG;
				btn.setAttribute('aria-label', isPlaying ? 'Pause slider' : 'Play slider');

				// Handle ring animation
				const fgCircle = btn.querySelector('.fg');
				if (fgCircle) {
					if (isPlaying) {
						fgCircle.style.animation = 'none';
						void fgCircle.offsetWidth;
						fgCircle.style.animation = '';
					} else {
						fgCircle.style.animation = 'none';
					}
				}
			}
		});
	};

	
	// Scroll the slider to a particular slide
	nmcSlider.prototype.advance = function(slideNumber, behavior) {
		if(typeof behavior === 'undefined') behavior = this.getBehavior();
		var length = this.getLength();
		var compStyles = window.getComputedStyle(this.$slider);
		var paddingLeft = Math.abs(compStyles.getPropertyValue('padding-left').replace('px', ''));
		var paddingRight = Math.abs(compStyles.getPropertyValue('padding-right').replace('px', ''));
		// clamp values
		if(slideNumber < 1) {
			this.advance(1,behavior);
			return;
		}
		if(slideNumber > length) {
			this.advance(length,behavior);
			return;
		}

		if (this.$slider.rtl) {
			this.$slider.scroll({
				left:  -Math.abs(this.$slider.clientWidth) + this.$slider.children[slideNumber - 1].offsetLeft + this.$slider.children[slideNumber - 1].clientWidth,
				behavior: behavior
			});
		} else {
			this.$slider.scroll({
				left: this.$slider.children[slideNumber - 1].offsetLeft - paddingLeft,
				behavior: behavior
			});
		}

		// reset video on slide change
		// this.$slider.querySelectorAll('iframe').forEach(function(iframe){
		// 	iframe.remove();
		// });

		// this.$slider.querySelectorAll('a[hidden]').forEach(function(hiddenLink){
		// 	hiddenLink.removeAttribute('hidden');
		// });
	}
	nmcSlider.prototype.scroll = function (slideNumber) {
		this.pause();
		this.advance(slideNumber,'smooth');
	}
	nmcSlider.prototype.slide = function (slideNumber) {
		this.pause();
		this.advance(slideNumber,'smooth');
	}
	nmcSlider.prototype.jump = function (slideNumber){
		this.pause();
		this.advance(slideNumber,'auto');
	}
	// just compute the next slide number
	nmcSlider.prototype._nextSlideNumber = function(count) {
		if(!count) count = 1;
		var next = this.getCurrent() + count;
		// we have to account for the need to loop before getting to the last slide
		// becuase the scroller won't push empty space
		if((next > this.getLength() || this.isAtTheEnd()) && this.shouldLoop()) {
			next = 1;
		}
		return next;
	}
	nmcSlider.prototype.next = function(count,isAuto) {
		if (isAuto !== true) {
			this.pause();
			this._setPlayButtonsState(false);
		}
		this.advance(this._nextSlideNumber(count));
	}
	nmcSlider.prototype._prevSlideNumber = function(count) {
		if (!count) count = 1;
		var current = this.getCurrent();
		var next = current - count;
		if(next < 1 && current == 1 && this.shouldLoop()) {
			next = this.getLength();
		}
		return next;
	}
	nmcSlider.prototype.prev = function(count) {
		this.pause();
		this._setPlayButtonsState(false);
		this.advance(this._prevSlideNumber(count));
	}


	nmcSlider.prototype.play = function() {
		var self = this;

		this._setPlayButtonsState(true);

		if (this.autoDuration() !== false) {
			this.interval = setInterval(function () {
				self.next(1, true);
			}, this.autoDuration());

			// NEW: restart ring animation immediately
			
		}
	}
	nmcSlider.prototype.pause = function() {
		clearInterval(this.interval);
		this.interval = false;
	}
	nmcSlider.prototype.playpause = function(){
		if (this.interval === false) {
			this.play();
			this._setPlayButtonsState(true); // ensure UI state sync
		} else {
			this.pause();
			this._setPlayButtonsState(false); // ensure UI state sync
		}
	}



	/*

	Slider Changes

	*/
	nmcSlider.prototype.onChange = function() {
		var self = this;
		this._setActiveClass();
		this.registeredButtons.forEach(function(button) { self._notifyButton(button); });
		if(this.$slider.dataset.nmcSliderResetIframes != null) {
			this.$slider.querySelectorAll('iframe').forEach(function(iframe){
				iframe.remove();
			});
		}
		var currentIndicator = document.querySelector('[data-current-slide="#'+ this.$slider.id +'"]');
		if (currentIndicator) {
			currentIndicator.innerHTML = this.currentCache;
		}
	}
	nmcSlider.prototype._notifyButton = function(button) {
		var self = this;
		button.dispatchEvent(new CustomEvent('nmcSliderChange',{
			bubbles: false,
			detail: { 
				current: self.currentCache,
				length: self.getLength(),
				shouldLoop: self.shouldLoop()
			}
		}));
	}
	nmcSlider.prototype._setActiveClass = function() {
		for(var i = 0; i < this.$slider.children.length; i++) {
			this.$slider.children[i].classList.remove('active');
			this.$slider.children[i].removeAttribute("aria-current");
		}
		this.$slider.children[this.getCurrent() - 1].classList.add('active');
		this.$slider.children[this.getCurrent() - 1].setAttribute("aria-current", "true");
	}
})();


// Buttons and the operations they allow
(function(){
	window.nmcSliderButton = function(arg) {
		var self = this;
		this.$button = (typeof arg === 'object') ? arg : document.querySelector(arg);
		
		this.$button.addEventListener('click',function(){
			self.dispatch(self.getTarget(),self.getAction(),self.getValue());
		});
		this.$button.addEventListener('nmcSliderChange',function(e){
			self._setStatusClass(e.detail);
		});
		this.register(this.getTarget());
	}
	nmcSliderButton.prototype.getTarget = function() {
		return this.$button.dataset.nmcSliderTarget;
	}
	nmcSliderButton.prototype.getAction = function() {
		return this.$button.dataset.nmcSliderAction.split('-')[0];
	}
	nmcSliderButton.prototype.getValue = function() {
		return this.$button.dataset.nmcSliderAction.split('-')[1];
	}
	nmcSliderButton.prototype.dispatch = function(target,action,value) {
		// console.log(target);console.log(action);console.log(value);
		var sliders = document.querySelectorAll(target);
		sliders.forEach(function(slider){
			slider.dispatchEvent(new CustomEvent('nmcSliderDispatch',{
				bubbles: false,
				detail: { 
					action: action,
					value: value
				}
			}));
		});
	}
	nmcSliderButton.prototype.register = function(target) {
		var self = this;
		var sliders = document.querySelectorAll(target);
		sliders.forEach(function(slider){
			slider.dispatchEvent(new CustomEvent('nmcSliderButtonRegister',{
				bubbles: false,
				detail: { 
					button: self.$button
				}
			}));
		});
	}
	nmcSliderButton.prototype._setStatusClass = function(data) {
		var action = this.getAction();
		var $btn = this.$button;
		// Prev
		if(action == 'prev') {
			if(data.current == 1 && !data.shouldLoop) {
				$btn.classList.add('disabled');
			} else {
				$btn.classList.remove('disabled');
			}

		}
		// Next
		if(action == 'next') {
			if(data.length == data.current && !data.shouldLoop) {
				$btn.classList.add('disabled');
			} else {
				$btn.classList.remove('disabled');
			}

		}
		
		
		// Specific
		if(action == 'scroll' || action == 'slide' || action == 'advance') {
			if(data.current == this.getValue()) {
				$btn.classList.add('active');
			} else {
				$btn.classList.remove('active');
			}
		}

		// Jump
		if(action == 'jump' ) {
			if(data.current == this.getValue()) {
				$btn.classList.add('active');
				$btn.setAttribute("aria-selected", "true");
			} else {
				$btn.classList.remove('active');
				$btn.removeAttribute("aria-selected");
			}
		}
	}
})();

(function(){
	window.nmcSliderInit = function(){
		document.querySelectorAll('[data-nmc-slider]').forEach(function(el){
			new nmcSlider(el);
		});
		document.querySelectorAll('[data-nmc-slider-target]').forEach(function(el){
			new nmcSliderButton(el);
		});
	}
})();

nmcSliderInit();


/* ------------------------------------------------------------------
   Helpers that keep every play-pause button in sync with the slider
-------------------------------------------------------------------*/


nmcSlider.prototype.pause = function () {
	clearInterval(this.interval);
	this.interval = false;

	/* NEW → update all play-pause buttons for this slider */
	this._setPlayButtonsState(false);
};